import {useRoute} from '@react-navigation/native';
import {
  Alert,
  ButtonBorder,
  Div,
  HeaderBack,
  ImageView,
  Label,
} from 'components';
import {Ecolors, Icons, urlApp} from 'constant';
import React, {useEffect, useRef, useState} from 'react';
import {View} from 'react-native';
import {apiAuth, configEkyc, convertDaTaCCCD, goBack, navigate} from 'services';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {convertStringTime, Log} from 'utils';
import {getStoreToken, setStoreToken} from 'utils/storage';
import LangJson from '../../../../trueidsdk/lang.json';
import {getInfo} from 'reducer/authen';

function ControlEKYCScreen() {
  const route = useRoute<any>();

  const countTime = useRef<number>(1);
  const [loading, setLoading] = useState(false);
  const [sdkReady, setSdkReady] = useState(false);
  const I18nState = useAppSelector(state => state.languages.I18nState);
  const statusScreen = useAppSelector(state => state.authen.statusScreen);
  const currentUser = useAppSelector<any>(state => state.authen.currentUser);
  const tokenRef = useRef<string>('');
  const dispatch = useAppDispatch();

  useEffect(() => {
    importSDK();
    getAccountToken();
    return () => {};
  }, []);

  const importSDK = () => {
    try {
      import('../../../../trueidsdk/TrueIDSDK')
        .then(() => setSdkReady(true))
        .catch(() => setSdkReady(false));
    } catch (error) {
      importSDK();
    }
  };

  const getAccountToken = async () => {
    try {
      setLoading(true);
      const t = await getStoreToken();
      const res = await apiAuth.login({
        username: route.params?.data?.phone,
        password: route.params?.data?.password,
      });
      if (res.status == 200) {
        tokenRef.current = res.data.access_token;
        await setStoreToken(res.data.access_token);
        await dispatch(getInfo({}));
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const gotoEKYC = async () => {
    if (!tokenRef.current) {
      const res = await apiAuth.login({
        username: route.params?.data?.phone,
        password: route.params?.data?.password,
      });
      if (res.status == 200) {
        tokenRef.current = res.data.access_token;
        await setStoreToken(res.data.access_token);
        await dispatch(getInfo({}));
      }
    }
    await dispatch(getInfo({}));
    if (window?.['TrueIDSDK'] && window?.['TrueIDSDK'].start) {
      let configEKYC_ = {
        ...configEkyc,
        accessToken: tokenRef.current || '',
      };
      Log('configEKYC_', {configEKYC_, I18nState});
      window?.['TrueIDSDK'].setLanguageJson(I18nState, LangJson);
      window?.['TrueIDSDK'].start(configEKYC_, bindReviewInfo);
    } else {
      Log('NULL');
    }
  };

  const bindReviewInfo = async scanData => {
    if (!scanData) return;

    const dataObj = await convertDaTaCCCD(scanData);

    const person = dataObj.userProfile;

    const userProfile = {
      gender: person?.gender,
      dob: person?.dob || '',
      nationalityId: 234,
      idTypeId: 1,
      idNo: person?.idNo,
      dateOfIssue: person?.dateOfIssue,
      placeOfIssue: person?.placeOfIssue,
    };

    const obj = {
      userProfile,
      userAddress: dataObj.userAddress,
      isKYC: dataObj.isKYC,
      name: person?.name,
      person,
      rawImage: dataObj.rawImage,
    };
    if (scanData?.decision?.code == -1) {
      Alert.showError({
        content: `alert.ekycfail`,
        onPress: () => {
          if (countTime.current >= 3) {
            navigate('LoginScreen');
            return;
          }
          gotoEKYC();
          countTime.current += 1;
        },
      });
      return;
    }
    navigate('ReviewInfoModal', {
      data: {
        ...obj,
        currentUser: {
          ...currentUser,
          ...(route.params?.data?.phone && {
            phone: route.params?.data?.phone,
          }),
          ...(route.params?.data?.password && {
            password: route.params?.data?.password,
          }),
          ...(route.params?.data?.name && {
            name: route.params?.data?.name,
          }),
          ...(route.params?.data?.email && {
            email: route.params?.data?.email,
          }),
        },
      },
    });
    return;
  };

  return (
    <Div height={'100%'}>
      <HeaderBack
        isShowStep={true}
        step={3}
        type={4}
        title={`setpasswordscreen.titletrong`}
      />
      <Div paddingHorizontal={29}>
        <Div width={'100%'} alignItems={'center'}>
          <Label
            marginTop={30}
            textAlign={'center'}
            size={20}
            fontWeight={'700'}>
            {`controlekyc.xacthucthongtin`}
          </Label>
          <Label marginTop={6} textAlign={'center'} size={14} lineHeight={20}>
            {`controlekyc.content`}
          </Label>
        </Div>
        <Label marginTop={40} size={14} lineHeight={20}>
          {`controlekyc.chuphinhmattruoc`}
        </Label>
        <Div
          flexDirection={'row'}
          marginTop={17}
          alignItems={'center'}
          justifyContent={'flex-start'}>
          <ImageView
            width={132}
            height={100}
            resizeMode={'contain'}
            source={Icons.before}
            marginRight={11}
          />
          <ImageView
            width={132}
            height={100}
            resizeMode={'contain'}
            source={Icons.after}
          />
          <ImageView
            height={1}
            resizeMode={'contain'}
            width={1}
            source={Icons.a}
          />
          <ImageView
            height={1}
            resizeMode={'contain'}
            width={1}
            source={Icons.closeee}
          />
          <ImageView
            height={1}
            resizeMode={'contain'}
            width={1}
            source={Icons.checked}
          />
          <ImageView
            height={1}
            resizeMode={'contain'}
            width={1}
            source={Icons.iconid}
          />
          <ImageView
            height={1}
            resizeMode={'contain'}
            width={132}
            source={Icons.id_card}
          />
          <ImageView
            height={1}
            resizeMode={'contain'}
            width={132}
            source={Icons.f}
          />
        </Div>
        <Label marginTop={18} size={14} lineHeight={20}>
          {`controlekyc.chuphinhchandung`}
        </Label>
        <Div>
          <ImageView
            height={100}
            marginTop={17}
            width={132}
            source={Icons.cmnd}
            resizeMode={'contain'}
          />
        </Div>
      </Div>
      <Div alignItems={'center'}>
        <ButtonBorder
          loading={loading}
          isDisable={!sdkReady}
          onPress={() => {
            gotoEKYC();
          }}
          marginTop={30}
          type={1}
          title={'controlekyc.batdau'}
        />
        <ButtonBorder
          marginTop={16}
          onPress={() => {
            if (statusScreen == 'main') {
              goBack();
              return;
            }
            navigate('LoginScreen');
          }}
          type={2}
          title={'controlekyc.thuchiensau'}
        />
      </Div>
      <View nativeID={'trueidsdk'} />
    </Div>
  );
}

export default React.memo(ControlEKYCScreen);
